/**
 * 页面缩放偏好状态管理 (Zustand)
 * 用户可手动调节页面内容的缩放比例，选择会持久化到本地缓存
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface UiScaleState {
  hydrated: boolean
  /** 用户是否手动设置过缩放比例；未设置时使用系统推荐值 */
  hasCustomScale: boolean
  /** 用户自定义的缩放比例 */
  customScale: number
  setHydrated: (hydrated: boolean) => void
  setCustomScale: (scale: number) => void
  resetToRecommended: () => void
}

export const useUiScaleStore = create<UiScaleState>()(
  persist(
    (set) => ({
      hydrated: false,
      hasCustomScale: false,
      customScale: 1,
      setHydrated: (hydrated) => set({ hydrated }),
      setCustomScale: (scale) => set({ hasCustomScale: true, customScale: scale }),
      resetToRecommended: () => set({ hasCustomScale: false }),
    }),
    {
      name: 'ui-scale-storage',
      onRehydrateStorage: () => (state) => {
        state?.setHydrated(true)
      },
      partialize: (state) => ({ hasCustomScale: state.hasCustomScale, customScale: state.customScale }),
    }
  )
)
